import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 import FPS_RO_Report from './FPS_RO_Report';


// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const  SDM_RO_data = async (params) => { 
         const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/SDM_RO_Report`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const SDM_RO_Report = ({  trans_date,dist_code,dist_name, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading); 
    const [renderContenttt, setRenderContenttt] = useState(null);
    const detailsLoadd = useRef(null);  

    
    const handleDistClick = (trans_date, dist_code, dist_name ,afso_code,afso_name) => {
        setRenderContenttt(null);
        
        setTimeout(() => {
            setRenderContenttt(
                <FPS_RO_Report trans_date={trans_date} dist_code={dist_code} dist_name={dist_name} office_code={afso_code} afso_name={afso_name} heading={tabHeading}/>
            );
        }, 10);
        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await  SDM_RO_data({trans_date , dist_code});
               
                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [trans_date,dist_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoadd.current) {
            // detailsLoad.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsLoadd.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
         }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        console.log(error);
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
    const totals = reportData.reduce(
        (acc, item) => {
          acc.tot_fps+=  parseFloat(item.tot_fps) || 0;
          acc.tot_order += parseFloat(item.tot_order) || 0;
          acc.tot_truck += parseFloat(item.tot_truck) || 0;
          acc.pending += parseFloat(item.pending) || 0;
          acc.received += parseFloat(item.received )|| 0;

          return acc;
        },
        {
            tot_fps: 0,
            tot_order: 0,
            tot_truck: 0,
            pending: 0,
            received: 0,
            
         }
      );
       
    return (
        <>
             <table align="center" width="50%" border={1}  ref={detailsLoadd}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}>
                        <font  style={{color: 'orange'}} > {dist_name} </font> 
                       {tabHeading} on 
                        <font  style={{color: 'orange'}} > {trans_date} </font> 
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>Office</th>
                        <th rowSpan={2}>No Of<br/>FPS</th>
                        <th rowSpan={2}>No Of<br/>Allocation<br/>Orders</th>
                        <th colSpan={3}>Truck Chits</th>
                     </tr>
                     <tr className="tableheader">
                        <th  >Total</th>
                        <th  >Received</th>
                        <th  >Pending for<br/>Receive</th>
                         </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.afso_code}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                            <a style={{ cursor: 'pointer', color: 'blue' }}
                                role="button" tabindex="0"
                                onClick={() => handleDistClick(trans_date,item.dist_code,item.dist_name_en,item.afso_code,item.afso_NAME_EN)} >
                                {item.afso_NAME_EN}
                                </a>
                                </td>
                            <td style={{ textAlign: 'right' }}>{item.tot_fps}</td>
                            <td style={{ textAlign: 'right' }}>{item.tot_order}</td>
                            <td style={{ textAlign: 'right' }}>{item.tot_truck}</td>
                            <td style={{ textAlign: 'right' }}>{item.received}</td>
                            <td style={{ textAlign: 'right' }}>{item.pending}</td>

                        </tr>
                    ))}
                </tbody>
                <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_fps}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_order}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_truck}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.received}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pending}</td>

            </tr>
            </table>
           
           <br />
            <div id="detailsERR">{renderContenttt}</div>
        
        </>
    );
};

export default SDM_RO_Report;
